export const DEFAULT_BACKGROUND_COLOR = "#D4FFD3";
export const LOADING_BACKGROUND_COLOR = "#FFFFFF";
